.root {
  display: flex;
  flex-direction: column;
  align-items: end;
}
